import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=6b1b1edc"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
import style0 from "./Room.vue?vue&type=style&index=0&id=6b1b1edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports